import type { MedicationStatementModel } from '@ctw/shared/api/fhir/models/medication-statement';
import { useFilteredSortedData } from '@ctw/shared/hooks/use-filtered-sorted-data';
import { useQueryAllPatientMedications } from '@ctw/shared/hooks/use-medications';
import { getDateRangeView } from '../resource/view-date-range';
import { defaultMedicationSortOverview } from './helpers/sorts';

export interface PatientMedicationsOverviewData {
  data: Array<MedicationStatementModel>;
  isLoading: boolean;
  hasNoRecords: boolean;
}

/**
 * Fetches, filters (past 6 months), and sorts the medications shown in the
 * patient overview card. `hasNoRecords` reflects the raw fetch so callers can
 * distinguish "no medications" from "none within the past 6 months".
 */
export function usePatientMedicationsOverviewData(): PatientMedicationsOverviewData {
  const query = useQueryAllPatientMedications();

  const { past6Months } = getDateRangeView<MedicationStatementModel>('lastActivityDate', false);

  const { data } = useFilteredSortedData({
    defaultSort: defaultMedicationSortOverview, // Alphabetical
    viewOptions: [past6Months],
    defaultView: past6Months.display,
    records: query.allMedications,
  });

  return {
    data,
    isLoading: query.isLoading,
    hasNoRecords: query.allMedications.length === 0,
  };
}
